const ONOBARDING_DATA_COLUMNS = [
  "Account",
  "Name",
  "Email",
  "Set Passwd",
  "Account Type",
  "State",
  "Account State",
  "Timestamp",
];

const REBALANCE_REQUESTED_DATA_COLUMNS = [
  "Account",
  "Name",
  "Current Cash",
  "Cash Target",
  "Excess Cash to Rebalance",
  "Performance",
];

const DEFAULT_DATA_COLUMNS = [
  "Account",
  "Name",
  "Email",
  "Account Type",
  "Account State",
  "Cash",
  "AUM",
  "Total AUM",
  "Advisory Fee",
  "Sub Advisory Fee",
  "Monthly Advisory",
  "Quarterly Sub Advisory",
  "Daily Sub Advisory",
  "Portfolio Start",
  "Portfolio Current",
  "Portfolio Maturity",
];

const SORTABLE_COLS = [
  "Name", "Email", "Account Type", "Account State", "AUM", "Cash", "Total AUM",
]

export { ONOBARDING_DATA_COLUMNS, REBALANCE_REQUESTED_DATA_COLUMNS, DEFAULT_DATA_COLUMNS, SORTABLE_COLS};